// Module
var code = "";
// Exports
var _module_exports =code;;
var path = 'public/app/features/datasources/partials/http_settings.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;